module.exports = __webpack_public_path__ + "img/edit-svg.d9b2ea8f.svg";